import {
	CaseReducer,
	createAsyncThunk,
	createSlice,
	PayloadAction,
} from '@reduxjs/toolkit';
import { eLeadType, STATUS } from '../globalContext/globalContext.interfaces';
import { IThunkApiExtra, RootState } from '../store';
import { LeadContext } from '../globalContext/leadContext.interface';
import { LeadStatusInfo } from '../globalContext/leadContext.interface';
import { IPropertyCard } from '@/components/templates/search/interfaces';
import { LeadRequest } from '@/components/templates/search/interfaces/ILeadRequest';


type State = LeadContext;

export const initialState: State = {
	status: STATUS.idle,
	leadStatusInfo: {
		success: null,
		message: '',
		data: {
			traceId: ''
		}
	},
	showGuestSignUpModal: false,
	showQuoteStatusModal: false,
	showContactStatusModal: false,
	selectedPropertyData: {
		badge: {
			backgroundColor: '',
			text: '',
			textColor: '',
			visible: false
		},
		bannos: [],
		beneficioCliente: null,
		cardWide: false,
		comuna: '',
		dormitorios: [],
		esDestacada: false,
		esFavorita: false,
		esOferta: false,
		idEstadoPropiedad: 0,
		horasPublicado: 0,
		imagenInmobiliaria: {
			alt: '',
			src: ''
		},
		imagenPrincipal: {
			alt: '',
			src: ''
		},
		oferta: {
			dsctoMonto: [],
			dsctoPorcentaje: 0,
			dsctoTitulo: '',
			precios: []
		},
		precios: [],
		region: '',
		superficie: [],
		tipoOperacion: '',
		tipoPropiedad: '',
		titulo: '',
		urlFicha: '',
		urlFichaItau: '',
		idProperty: 0
	}
}

const setShowGuestSignUpModalReducer: CaseReducer<State, PayloadAction<boolean>> = (state, action) => {
	state.showGuestSignUpModal = action.payload;
}

const setSelectedPropertyDataReducer: CaseReducer<State, PayloadAction<IPropertyCard>> = (state, action) => {
	state.selectedPropertyData = { ...state.selectedPropertyData, ...action.payload};
}

const setShowQuoteStatusModalReducer: CaseReducer<State, PayloadAction<boolean>> = (state, action) => {
	state.showQuoteStatusModal = action.payload;
}

const setShowContactStatusModalReducer: CaseReducer<State, PayloadAction<boolean>> = (state, action) => {
	state.showContactStatusModal = action.payload;
}

export const sendLead = createAsyncThunk<LeadStatusInfo, LeadRequest, { extra: IThunkApiExtra }>(
	'lead/sendLead',
	async (request: LeadRequest | undefined, thunkApi) => {
		const { rejectWithValue, extra } = thunkApi;
		if (request === undefined) return rejectWithValue('Se necesitan los datos para poder enviar el lead');

		const { propertyId, originId } = request ?? {};
		if (propertyId === null || propertyId === undefined || propertyId === 0) return rejectWithValue('Se necesita el id de la propiedad.');
		if (originId === null || originId === undefined || originId === 0) return rejectWithValue('Se necesita el origen.');

		const { services } = extra;
		const servicesList = (await services()).setupServices()
		return (await servicesList.generateLead(request)) as LeadStatusInfo;
	}
)

export const LeadSlice = createSlice({
	name: 'lead',
	initialState,
	reducers: {
		setShowGuestSignUpModal: setShowGuestSignUpModalReducer,
		setSelectedPropertyData: setSelectedPropertyDataReducer,
		setShowQuoteStatusModal: setShowQuoteStatusModalReducer,
		setShowContactStatusModal: setShowContactStatusModalReducer,
	},
	extraReducers: builder => {
		builder.addCase(sendLead.pending, (state) => {
			state.status = STATUS.pending;
		})
		builder.addCase(sendLead.fulfilled, (state, action) => {
			const { success, message } = action.payload ?? {};
			if (state.selectedPropertyData.idEstadoPropiedad === eLeadType.quote) {
				state.leadStatusInfo.success = success;
				state.leadStatusInfo.message = message;
				state.showQuoteStatusModal = true;
				state.showGuestSignUpModal =  false;
			} else {
				state.leadStatusInfo.success = success;
				state.leadStatusInfo.message = message;
				state.showContactStatusModal = true;
				state.showGuestSignUpModal =  false;
			}
		})
		builder.addCase(sendLead.rejected, (state) => {
			state.leadStatusInfo.success = false;
			state.showContactStatusModal = true;
			state.showGuestSignUpModal =  false;
			state.leadStatusInfo.message = 'Ha ocurrido un error, inténtelo más tarde.';
			state.status = STATUS.error;
		})
	}
})

export const selectLeadState = (state: RootState) => state.LeadState;
export const selectShowGuestSignUpModal = (state: RootState) => state.LeadState.showGuestSignUpModal;
export const { setShowGuestSignUpModal, setSelectedPropertyData, setShowQuoteStatusModal, setShowContactStatusModal } = LeadSlice.actions;